import { render, staticRenderFns } from "./MyTab.vue?vue&type=template&id=08bc1c68&scoped=true"
import script from "./MyTab.vue?vue&type=script&lang=js"
export * from "./MyTab.vue?vue&type=script&lang=js"
import style0 from "./MyTab.vue?vue&type=style&index=0&id=08bc1c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc1c68",
  null
  
)

export default component.exports